import gdpr from '../report/util/gdpr-globals';

export function getCookie(name: string): string {
  if (document.cookie.length > 0) {
    let start = document.cookie.indexOf(name + `=`);
    if (start !== -1) {
      start = start + name.length + 1;
      let end = document.cookie.indexOf(`;`, start);
      if (end === -1) {
        end = document.cookie.length;
      }
      return unescape(document.cookie.substring(start, end));
    }
  }
  return ``;
}

export function setCookie(name: string, value: string, expireDays: number, crossSubdomain = false): void {
  if (!gdpr.isReady) {
    console.warn(`Attempted to set cookie before GDPR data initialized`);
    return;
  }

  if (!gdpr.allowStorage) {
    return;
  }

  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + expireDays);
  const domainMatch = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i.exec(document.location.hostname);

  document.cookie = [
    `${name}=${escape(value)}`,
    expireDays === null ? `` : `expires=${expirationDate.toUTCString()}`,
    `path=/`,
    crossSubdomain && domainMatch ? `domain=.${domainMatch[0]}` : ``,
  ]
    .filter(Boolean)
    .join(`;`);
}

export function removeCookie(name, crossSubdomain = false): void {
  setCookie(name, ``, -1, crossSubdomain);
}

export function cookieExists(name: string): boolean {
  if (document.cookie.length > 0) {
    const start = document.cookie.indexOf(name + `=`);
    if (start !== -1) {
      return true;
    }
  }
  return false;
}
